jQuery(document).ready(function () {
  var phoneInput = document.getElementById('edit-phone-number');

  if (phoneInput != null) {
    phoneInput.addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
    });
  }
});
